(() => {
  if (customElements.get('multiple-add-products')) {
    return;
  }

  class MultipleAddProducts extends HTMLElement {
    constructor() {
      super();

      this.onButtonClick = this.onButtonClick.bind(this);
    }

    connectedCallback() {
      this.init();
      this.attachEvents();
    }

    disconnectedCallback() {
      this.detachEvents();
    }

    attachEvents() {
      this.button?.addEventListener('click', this.onButtonClick);
    }

    detachEvents() {
      this.button?.removeEventListener('click', this.onButtonClick);
    }

    init() {
      this.button = this.querySelector('[data-add-products]');
      this.variantIds = this.querySelector('input[name="variant_ids"]');
    }

    onButtonClick(event) {
      if (!this.variantIds || this.variantIds.value === '') {
        return;
      }

      event.preventDefault();

      this.button.classList.add('disabled');

      const ids = this.variantIds.value.split(',').map(id => id.trim());
      const formData = new FormData();

      ids.forEach((id, index) => {
        formData.append(`items[${index}][id]`, Number(id));
        formData.append(`items[${index}][quantity]`, 1);
      });

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', Cart.getLiveRegions().map((section) => section.section).join(','));

      Cart.add(formData)
        .then((response) => response.json())
        .then((response) => {
          if(response.sections) {
            Object.entries(response.sections).forEach(([key, html]) => {
              const elementToReplace = document.querySelector(`#${key}`);
              if (!elementToReplace) return;
              elementToReplace.innerHTML = html;
            });
          }

          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          triggerToastMessage('add');
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.button.classList.remove('disabled');
          this.showSamplesModal();
        });
    }

    async showSamplesModal() {
      const samplesModal = document.querySelector('#sample-popup');
      const cartData = await fetch('/cart.js').then((response) =>
        response.json(),
    );

    const hasSamples = cartData.items.some(
      (item) =>
        item.properties &&
      (item.properties.type === 'sample' ||
        item.properties.type === 'sample-deluxe'),
      );

      if (!hasSamples && samplesModal) {
        samplesModal.showModal();
      }
    }

    /**
     * Handle error message.
     *
     * @param {String/Object} errorMessage Comes from Shopify.
     * @returns {Void}
     */
    handleErrorMessage(errorMessage = false) {
      const errorWrapper = this.querySelector('[data-error-wrapper]');
      if (!errorWrapper || !errorMessage) return;

      window.dispatchEvent(
        new CustomEvent('formError', { detail: errorMessage }),
      );
      errorWrapper.classList.toggle('hidden', !errorMessage);

      if (typeof errorMessage == 'string') {
        errorWrapper.textContent = errorMessage || '';
      }
    }
  }

  customElements.define('multiple-add-products', MultipleAddProducts);
})();
